import axios from 'axios';

const BillingService = {
  createCheckoutSession: (tierId) =>
    axios.post('/billing/checkout-session', { tierId }),

  createPortalSession: () => axios.post('/billing/portal-session'),

  getUsage: (organizationId) =>
    axios.get(`/organizations/${organizationId}/usage`),

  getCheckoutSessionStatus: (sessionId) =>
    axios.get(`/billing/checkout-session/${sessionId}`),
};

export default BillingService;

